export default {
	"f8cd85d283ae7c315e157c9265ad1a86": "Saving...",
	"12b7edf9dfaddb39c1c28bd3cca3423e": "Save the picture to the album"
}
